import React from "react";
import PropTypes from "prop-types";

const TabNav = ({ tabs, activeTab, onChange, className = "" }) => {
  return (
    <div className={`custom-tabs mt-0 ${className}`.trim()}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`tab-item ${activeTab === tab.key ? "active" : ""}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
          {tab.count !== undefined && (
            tab.badge
              ? <span className="badge">{tab.count}</span>
              : <span>({tab.count})</span>
          )}
        </div>
      ))}
    </div>
  );
};

TabNav.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
      badge: PropTypes.bool,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TabNav;
